
import { toast } from 'sonner';

interface ToastOptions {
  title?: string;
  description?: string;
  duration?: number;
  userAvatar?: string;
  userName?: string;
  userId?: string;
}

interface ErrorToastOptions extends ToastOptions {
  stepNumber?: number;
  errorType?: string;
  canRetry?: boolean;
  onRetry?: () => void;
  onReportError?: () => void;
}

export const showSuccessToast = (options: ToastOptions) => {
  toast.success(options.title || 'Sucesso', {
    description: options.description,
    duration: options.duration || 4000,
  });
};

export const showInfoToast = (options: ToastOptions) => {
  toast.info(options.title || 'Informação', {
    description: options.description,
    duration: options.duration || 4000,
  });
};

export const showWarningToast = (options: ToastOptions) => {
  toast.warning(options.title || 'Atenção', {
    description: options.description,
    duration: options.duration || 5000,
  });
};

export const showErrorToast = (options: ToastOptions) => {
  toast.error(options.title || 'Erro', {
    description: options.description,
    duration: options.duration || 6000,
  });
};

// Toast específico para erros de onboarding
export const showOnboardingErrorToast = (options: ErrorToastOptions) => {
  const { stepNumber, errorType, canRetry, onRetry, onReportError, ...toastOptions } = options;
  
  const actions: any = {};
  
  if (canRetry && onRetry) {
    actions.action = {
      label: 'Tentar Novamente',
      onClick: onRetry
    };
  }

  toast.error(toastOptions.title || 'Erro no Onboarding', {
    description: toastOptions.description || 'Ocorreu um erro ao salvar os dados do onboarding',
    duration: 8000,
    ...actions,
    // Adicionar botão secundário para reportar erro se fornecido
    ...(onReportError && {
      cancel: {
        label: 'Reportar Problema',
        onClick: onReportError
      }
    })
  });
};

// Toast para salvamento bem-sucedido de passo
export const showStepSavedToast = (stepNumber: number, stepName?: string) => {
  showSuccessToast({
    title: 'Dados salvos',
    description: `Passo ${stepNumber}${stepName ? ` (${stepName})` : ''} salvo com sucesso!`,
    duration: 3000
  });
};

// Toast para validação falhando
export const showValidationErrorToast = (message: string, fieldName?: string) => {
  showErrorToast({
    title: 'Erro de validação',
    description: fieldName ? `${fieldName}: ${message}` : message,
    duration: 5000
  });
};
